import script from "./AnnouncementBar.vue?vue&type=script&setup=true&lang=js"
export * from "./AnnouncementBar.vue?vue&type=script&setup=true&lang=js"

import "./AnnouncementBar.vue?vue&type=style&index=0&id=62a87c6d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62a87c6d"]])

export default __exports__